import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const routeLabels: Record<string, string> = {
  "/": "Home",
  "/qday-estimator": "Q-Day Estimator",
  "/crypto-break-simulator": "Crypto Break Time Simulator",
  "/scorecard": "Quantum Readiness Scorecard",
  "/simulator": "Q-Day Simulator",
  "/migration-advisor": "Migration Advisor",
  "/migration-cockpit": "Migration Cockpit",
  "/user-guide": "User Guide",
  "/workshop-handouts": "Workshop Handouts",
  "/methodology": "Methodology",
  "/sources": "Sources & Validation",
  "/privacy-policy": "Privacy Policy",
  "/cookie-policy": "Cookie Policy",
  "/terms-of-use": "Terms of Use",
  "/copyright": "Copyright",
  "/license-compliance": "License Compliance",
};

export const BreadcrumbSchema = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentLabel = routeLabels[currentPath] || "Page";

  useEffect(() => {
    const existingScript = document.getElementById("breadcrumb-jsonld");
    if (existingScript) {
      existingScript.remove();
    }

    const breadcrumbItems = [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://q-dayclock.com/"
      }
    ];

    if (currentPath !== "/") {
      breadcrumbItems.push({
        "@type": "ListItem",
        "position": 2,
        "name": currentLabel,
        "item": `https://q-dayclock.com${currentPath}`
      });
    }

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbItems
    };

    const script = document.createElement("script");
    script.id = "breadcrumb-jsonld";
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById("breadcrumb-jsonld");
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [currentPath, currentLabel]);

  return null;
};
